import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=49b635d2&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=ts"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=49b635d2&prod&lang=css"
import style1 from "./SidebarMenuItem.vue?vue&type=style&index=1&id=49b635d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b635d2",
  null
  
)

export default component.exports